const PERIOD_MONTHS = {
  monthly: 1,
  quarterly: 3,
  semester: 6,
  annual: 12
};

export function getPeriodMultiplier(paymentFrequency) {
  if (!paymentFrequency || typeof paymentFrequency !== "string") return 1;
  return PERIOD_MONTHS[paymentFrequency.toLowerCase()] ?? 1;
}

export function getDisplaySubscriptionValue(value, paymentFrequency, totalM2) {
  const num = Number(value);
  return num;
}
